import { render } from "./QCChartReport.vue?vue&type=template&id=ca29af70&scoped=true"
import script from "./QCChartReport.vue?vue&type=script&lang=js"
export * from "./QCChartReport.vue?vue&type=script&lang=js"

import "./QCChartReport.vue?vue&type=style&index=0&id=ca29af70&lang=scss"
import "./QCChartReport.vue?vue&type=style&index=1&id=ca29af70&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca29af70"],['__file',"src/components/QCCharts/QCChartReport.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca29af70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca29af70', __exports__)) {
    console.log('reload')
    api.reload('ca29af70', __exports__)
  }
  
  module.hot.accept("./QCChartReport.vue?vue&type=template&id=ca29af70&scoped=true", () => {
    console.log('re-render')
    api.rerender('ca29af70', render)
  })

}


export default __exports__